import React from 'react';
import Button from '../button/Button';
import { BUTTON_TYPE } from '../button/constants';
import styles from './Breadcrumbs.style';
import useTxNavigate from '../../../libs/txnavigate/TxNavigateHook';

export default function Breadcrumbs({ items }) {

    const navigate = useTxNavigate();

    const handleBreadcrumbClick = (item) => {
        if (item.link) {
            navigate(item.link);
        }
    };

    return (
        <nav aria-label="breadcrumb">
            <ol style={styles.breadcrumb}>
                {items.map((item, index) => (
                    <React.Fragment key={index}>
                        <li
                            key={index}
                            style={{...styles.breadcrumbItem, ...(index === items.length - 1 ? styles.breadcrumbActiveItem : {})}}
                            aria-current={index === items.length - 1 ? 'page' : null}
                        >
                            {index === items.length - 1 ? (
                                item.text
                            ) : item.link ? (
                                <Button
                                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                    style={styles.breadcrumbLink}
                                    onClickCb={() => handleBreadcrumbClick(item)}
                                >
                                    {item.text}
                                </Button>
                                ) : (
                                    <span>{item.text}</span>
                            )}
                        </li>
                        {index < items.length - 1 && (
                            <li style={styles.breadcrumbSeparator}>&gt;</li>
                        )}
                    </React.Fragment>
                ))}
            </ol>
        </nav>
    );
}